import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { breakpoints } from '../../../resources/scripts/config/breakpoints';

export function updateHeaderStyles(isActive) {
  const header = document.querySelector('header');
  const headerLogo = header.querySelectorAll('div > span');
  const headerGamburger = header.querySelector('.header__hamburger');

  if (window.innerWidth < breakpoints.sm) {
    header.style.backgroundColor = isActive ? 'rgb(240, 235, 226)' : '';
    header.style.borderBottom = isActive ? '1px solid rgba(26, 26, 26, 0.2)' : '';
    headerGamburger.style.color = isActive ? 'rgb(0,0,0)' : '';

    headerLogo.forEach((letter) => {
      // eslint-disable-next-line no-param-reassign
      letter.style.color = isActive ? 'rgb(0,0,0)' : '';
    });
  }
}

export function getDynamicWidth(contentBlocks) {
  let totalWidth = 0;

  contentBlocks.forEach((block) => {
    totalWidth += block.getBoundingClientRect().width;
  });

  return totalWidth;
}

gsap.registerPlugin(ScrollTrigger);

export function initServicesScroll() {
  let isKeyboardNavigation = false;
  let preventScrollTriggerUpdate = false;

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      isKeyboardNavigation = true;
    }
  });

  document.addEventListener('mousedown', () => {
    isKeyboardNavigation = false;
  });

  document.addEventListener('focusin', () => {
    if (isKeyboardNavigation) {
      preventScrollTriggerUpdate = true;
    }
  });

  document.addEventListener('focusout', () => {
    preventScrollTriggerUpdate = false;
  });

  const tabs = document.querySelectorAll('.intro-service__tab');
  const contentBlocks = document.querySelectorAll('.intro-service__columns');
  const section = document.querySelector('.services');

  if (section && tabs.length && contentBlocks.length && window.innerWidth >= breakpoints.lg) {
    const totalWidth = getDynamicWidth(contentBlocks);

    ScrollTrigger.create({
      trigger: section,
      start: window.innerWidth < breakpoints.sm ? '-=40px top' : 'top top',
      end: () => `+=${totalWidth}`,
      pin: true,
      scrub: true,
      anticipatePin: 1,
      onEnter: () => updateHeaderStyles(true),
      onEnterBack: () => updateHeaderStyles(true),
      onLeave: () => updateHeaderStyles(false),
      onLeaveBack: () => updateHeaderStyles(false),
      onUpdate: (self) => {
        if (preventScrollTriggerUpdate) {
          return;
        }

        let index = Math.floor(self.progress * contentBlocks.length);

        if (index >= contentBlocks.length) {
          index = contentBlocks.length - 1;
        }

        tabs.forEach((tab, i) => {
          tab.classList.toggle('active', i === index);
          contentBlocks[i]?.classList.toggle('active', i === index);
        });
      },
    });

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        isKeyboardNavigation = false;
        gsap.to(window, {
          scrollTo: {
            y: contentBlocks[index].offsetTop,
            autoKill: false,
          },
          duration: 1,
        });
      });
    });
  }
}

export function pinTab() {
  const tabsContainer = document.querySelector('.intro-service__tabs');

  if (tabsContainer) {
    const tabs = tabsContainer.querySelectorAll('a');
    let scrollLeft = 0;

    for (let i = 0; i < tabs.length; i++) {
      scrollLeft += tabs[i].offsetWidth;
      if (tabs[i].classList.contains('active')) {
        break;
      }
    }

    const scrollLeftNumber = scrollLeft - tabsContainer.offsetWidth;
    if (scrollLeft > 0) {
      tabsContainer.scrollLeft = scrollLeftNumber;
    }
  }
}

window.addEventListener('load', () => {
  pinTab();
});
